import * as VueRouter from 'vue-router';
import { Authority } from '@/shared/model/authority';
import { createRouter } from 'vue-router';

import admin from '@/router/admin';
import pages from '@/router/pages';

const Home = () => import('@/core/home/home-oauth.vue');
const Error = () => import('@/core/error/error.vue');
const UserRegistrationComponent = () => import('@/core/user-registration/user-registration.vue');

// prettier-ignore
export function initRouter() {
  return createRouter({
    history: VueRouter.createWebHistory(),
    routes: [
      {
        path: '/',
        name: 'Home',
        component: Home,
        meta: { authorities: [Authority.SUPERADMIN, Authority.ADMIN, Authority.USER] },
      },
      {
        path: '/forbidden',
        name: 'Forbidden',
        component: Error,
      },
      {
        path: '/not-found',
        name: 'NotFound',
        component: Error,
      },
      {
        path: '/user-registration',
        name: 'UserRegistration',
        component: UserRegistrationComponent,
      },
      ...admin,
      ...pages,
    ]
  });
}
